import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
import i18n from '@plugins/i18n'

export const state = {
  repositories: {}
}

export const mutations = {
  SET_REPOSITORIES(state, value) {
    state.repositories = value
  }
}
export const getters = {
  getRepositoryFields() {
    return {
      model: 'repositories_classification',
      label: 'Repositories',
      fields: [
        { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
        {
          key: 'login_required', label: 'Login Required', type: 'boolean', sortable: true, required: true, default: false, formatter: (value, key, item) => {
            return value ? i18n.t('basic.yes') : i18n.t('basic.no')
          }
        },
        {
          key: 'approval_flow', label: 'Approval Flow', type: 'boolean', sortable: true, required: true, default: false, formatter: (value, key, item) => {
            return value ? i18n.t('basic.yes') : i18n.t('basic.no')
          }
        },
        {
          key: 'field', label: 'Fields', type: 'array_model',
          model_source: 'Fields', model_route: 'management/masters/fields',
          sortable: true, required: true,
          formatter: (value, key, item) => {
            return item.field.order
          }
        },
        {
          key: 'file', label: 'Files', type: 'array_model',
          model_source: 'Files', model_route: 'management/masters/files',
          sortable: true, required: true,
          formatter: (value, key, item) => {
            return item.file.length
          }
        },


      ]
    }
  },
  getRepositories(state) {
    return state.repositories
  }
}

export const actions = {
  async fetchRepositories({ commit, state }, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/classifications/${query}`)
      .then((response) => {
        commit('SET_REPOSITORIES', response.data)
        return response.data;
      })
  },

  async createRepositories({ commit, state }, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/classifications/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateRepositories(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/classifications/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteRepositories(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/classifications/${id}/`)
      .then((response) => {
        return response.data;
      })
  },
  fetchRepositoriesOptions(context, query) {
    query = query || ''
    return axios.options(`${serverUrl}/api/masters/classifications/${query}`).then((response) => {
      return response.data
    })
  },
}
